import React from 'react';

const ImageOutline = () => (
  <g>
    <path
      d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.1 11.9L11.1 15.8L9 13.1L6 17H18L14.1 11.9Z"
      fill="currentColor"
    />
  </g>
);

export default ImageOutline;
